/**
 * NotificationsBell
 *
 * Icono + badge + popover. Vive en su propio archivo porque Header ya tiene
 * varios mocks y queremos que el bell sea testeable aisladamente.
 */

import { useState, useCallback } from 'react';
import { IconButton, Badge } from '@mui/material';
import { Notifications as NotificationsIcon } from '@mui/icons-material';
import { useNotificationsStore } from '@/store/notificationsStore';
import { NotificationsPanel } from './NotificationsPanel';

export function NotificationsBell() {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const unreadTotal = useNotificationsStore((s) => s.unreadTotal);

  const handleOpen = useCallback((e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  }, []);
  const handleClose = useCallback(() => setAnchorEl(null), []);

  const open = Boolean(anchorEl);
  const badgeCount = unreadTotal > 99 ? 99 : unreadTotal;

  return (
    <>
      <IconButton
        color="inherit"
        aria-label="notificaciones"
        onClick={handleOpen}
        data-testid="notifications-bell"
        aria-haspopup="true"
        aria-expanded={open ? 'true' : 'false'}
      >
        <Badge badgeContent={badgeCount} color="error" max={99} data-testid="notifications-badge">
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <NotificationsPanel open={open} anchorEl={anchorEl} onClose={handleClose} />
    </>
  );
}

export default NotificationsBell;
